import { Reveal, ChapterTag } from "@/components/Reveal";

const STEPS = [
  { n: "01", title: "Tell Us Your Vision", copy: "Tell us where you want to go, your dates, preferences and approximate budget." },
  { n: "02", title: "We Plan", copy: "We create a personalized journey around your requirements." },
  { n: "03", title: "We Coordinate", copy: "We coordinate the selected travel arrangements, stays, local transportation, sightseeing and experiences." },
  { n: "04", title: "You Experience", copy: "You travel, relax and enjoy while we coordinate the details." },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="bg-obsidian px-5 py-20 sm:px-8 sm:py-28 lg:px-16 lg:py-36">
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <ChapterTag index="04" label="The Process" />
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-10 font-serif text-4xl font-light leading-tight tracking-tight text-zinc-50 sm:text-5xl">
          A simpler way <span className="italic text-gold-gradient">to travel.</span>
        </h2>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={0.1 + i * 0.12}>
            <div data-testid={`step-${s.n}`} className="group relative border-t border-white/10 pt-8 transition-colors duration-500 hover:border-gold/60">
              <span className="font-serif text-6xl font-light text-white/10 transition-colors duration-500 group-hover:text-gold/40">
                {s.n}
              </span>
              <h3 className="mt-4 font-serif text-xl font-normal text-zinc-100 sm:text-2xl">{s.title}</h3>
              <p className="mt-3 text-sm font-light leading-relaxed text-zinc-400">{s.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
